import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get } from 'lodash';
import PageHelmet from '@bd/bdcore-pagehelmet';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import MenuAbout from '../../components/MenuAbout';
import PageIntroBanner from '../../components/PageIntroBanner';
import PageSection from '../../components/PageSection';
import PageSectionContent from '../../components/PageSectionContent';

function CommunityOverview({ page }) {
  return (
    <PageWrapper>
      <PageHelmet page={page} />
      <InsideHeader
        h1="Community Overview"
        background={get(page, 'page_image.contentUrl')}
      />
      <MenuAbout />
      <PageIntroBanner
        headline={get(page, 'page_intro_banner[0].headline')}
        body={get(page, 'page_intro_banner[0].text')}
      />
      <PageSection fullwidth>
        {
          page.sections.map(item => (
            <PageSectionContent
              alternating
              key={item.title}
              preTitle={item.pre_title}
              title={item.title}
              body={item.body}
              media={
                <div
                  className="ContentBanner_resultMediaInner"
                  style={{ backgroundImage: `url('${buildThumbnailUrl(get(item, 'image.contentUrl'), { width: 1200, height: 1200 })}')` }}
                />
              }
            />
          ))
        }
      </PageSection>
    </PageWrapper>
  );
}

CommunityOverview.propTypes = {
  page: PropTypes.object.isRequired,
  // communities: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData({
  page: 'community_overview',
  // communities: true,
})(CommunityOverview);



// WEBPACK FOOTER //
// ./src/pages/CommunityOverview/index.js